import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { EnvironmentConfiguration } from './environment/services/environment.configuration';
import { BpgCommonService } from './bpg-common/services/bpg-common.service';
import { environment } from 'src/environments/environment';
import { environmentLocal } from 'src/environments/environment.local'
import { environmentQA } from 'src/environments/environment.qa'
import { environmentPROD } from 'src/environments/environment.prod'

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private readonly bpgCommonService: BpgCommonService, private readonly environment: EnvironmentConfiguration) { }


  canActivate(
    _next: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot): Observable<any> | Promise<any> | boolean {

    // Ensure QA/PROD auth flow always runs on erg host to keep PKCE session storage on one origin.
    const currentHostname = window.location.hostname;
    const redirectHost =
      this.environment.envName === 'qa' && currentHostname === 'qa.bpg.toyota.com'
        ? 'qa.erg.toyota.com'
        : this.environment.envName === 'prod' && currentHostname === 'bpg.toyota.com'
          ? 'erg.toyota.com'
          : null;
    if (redirectHost) {
      const url = new URL(window.location.href);
      url.hostname = redirectHost;
      window.location.href = url.toString();
      return false;
    }

    //Check to run application locally or in staging/production using ADAL Authentication 
    
    const codefromurl = sessionStorage.getItem('codeResponse');

    const token = sessionStorage.getItem('id_token');

    const refreshToken = sessionStorage.getItem('refresh_token');

    const accessToken = sessionStorage.getItem('access_token');

    if (codefromurl != null && token != null && refreshToken != null && accessToken != null &&

      codefromurl !== undefined && token !== undefined && refreshToken !== undefined && accessToken !== undefined) {

      return true

    }
    else if (codefromurl !== null && sessionStorage.getItem('id_token') === null) {
        return this.bpgCommonService.userLogin();
      }

      else {
        let baseLoginUrl;
        if (this.environment.envName === 'default' || this.environment.envName === 'local' || this.environment.envName === 'staging') {
          baseLoginUrl = environmentLocal.baseLoginUrl
        } else if (this.environment.envName === 'qa') {
          baseLoginUrl = environmentQA.baseLoginUrl
        }
        else if (this.environment.envName === 'prod') {
          baseLoginUrl = environmentPROD.baseLoginUrl
        }
        localStorage.setItem("redirectURl",window.location.href);
        const redirectUrl = baseLoginUrl + environment.codeChallenge;
        window.location.href = redirectUrl;
        return true;
      }
    }
}
